import { ContractInfoType } from '@/types/api/mypage/contractInfo';
import { atom } from 'recoil';
import persistAtom from './recoilPersist';

/**
 * 契約者情報の初期値。
 * ログイン直後や未取得状態でも画面が安全に参照できるよう、空文字中心の初期形を定義している。
 */
export const customerDefaultState: ContractInfoType = {
  contract_no: '',
  last_name: '',
  first_name: '',
  last_name_kana: '',
  first_name_kana: '',
  gender: '',
  email: '',
  birthday: '',
  zip_code: '',
  prefecture: '',
  city: '',
  town: '',
  address_optional: '',
  tel: '',
  tel_daytime: '',
};

/**
 * 契約者情報の state。
 * 氏名・住所・連絡先など多数の画面で共通参照する情報なので、取得後はセッション中の基礎データとして保持する。
 */
export const CustomerInfoState = atom<ContractInfoType>({
  key: 'CustomerInfoState',
  default: customerDefaultState,
  effects_UNSTABLE: [persistAtom],
});

export default CustomerInfoState;
